module.exports = __webpack_public_path__ + "media/images/logos/gitlab-2f7432a05b9dd36e849ec021208245ef.png";